module.exports = __webpack_public_path__ + "static/img/3.399902a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mockups/screenshots/3.jpg
// module id = Kbmo
// module chunks = 0